import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DocumentsTable from './table/DocumentsTable';
import { actions as newDocumentActions } from './store/actions/new-document.actions';
import { documentsActions } from './store/actions/documents.actions';
import {
  chooseDocumentFilter,
  fetchDocumentFilters,
} from './store/actions/documentFilter/documentFilterActions';
import NewRequestContainer from '../CreateRequest/new-request.container';
import NewDocumentContainer from './newDocument/new-document.container';
import EditDocumentContainer from './editDocument/edit-document.container';
import WarrantyContainer from '../warranty-form.container';
import WarrantyInfoContainer from '../warranty-info-form.container';
import OrgInParamsFormContainer from '../org-in-params-panel.container';
import AddOrgsContainer from '../add-orgs.container';
import ExecuterContainer from '../set-executer-panel.container';
import MasterContainer from '../set-master-panel.container';
import ServiceContainer from '../set-service-panel.container';
import {
  Menu,
  Dropdown,
  Col,
  Row,
  Affix,
  Button,
  Input,
  Spin,
  Tooltip,
  Alert,
  Icon,
} from 'antd';

import DeleteDocuments from './DeleteDocuments/DeleteDocuments';
import FilterDrawer from './filter/FilterDrawer/FilterDrawer';
import getDocumentDefaultFilter from './requests/getDocumentDefaultFilter';
import resetDocumentDefaultFilter from './requests/resetDocumentDefaultFilter';
import { setRefreshFn } from '../../actions/refreshActions';
import { shortFilterName } from '../../helpers/filterName';
import FromNotificationAlert from '../../components/FromNotificationAlert/FromNotificationAlert';
import { ExpiredDocsButton } from './ExpiredDocsButton';
import { getDocTitle } from './table/utils/getDocTitle';
import { CompanyDocumentReminder } from './CompanyDocumentReminder/CompanyDocumentReminder';
import { MassDownload } from './MassDownload/MassDownload';
import FilterDrawerNew from './FilterDrawerNew';
import {
  chooseDocumentFilterNew,
  resetFilter,
} from './store/actions/documentFilterNew.actions';
import RelatedDocsModal from './components/RelatedDocsModal/RelatedDocsModal';
import DocForm from './components/DocFormProvider';

const Search = Input.Search;

class DocumentsContainer extends Component {
  state = {
    fromNotificationsTexts: undefined,
  };

  getDefaultFilter = async () => {
    const defaultFilter = await getDocumentDefaultFilter();

    await this.props.dispatch(fetchDocumentFilters());

    if (defaultFilter && this.props.filters.data.length > 0) {
      this.props.dispatch(chooseDocumentFilter(defaultFilter.id));
      this.props.dispatch(chooseDocumentFilterNew(defaultFilter.id));
    } else {
      this.props.dispatch(documentsActions.fetchDocuments());
    }
  };

  async componentDidMount() {
    const { from, id, texts } = this.props.location.state || {};
    const isFromNotifications = from === 'notifications' && Boolean(id);

    if (isFromNotifications) {
      this.props.dispatch(documentsActions.getDocumentByNumber(id));
      this.setState({ fromNotificationsTexts: texts });
      this.props.history.replace({ state: undefined });
    } else {
      this.getDefaultFilter();
    }

    this.props.dispatch(documentsActions.fetchStatuses(this.props));

    const refreshFn = () => {
      this.props.dispatch(documentsActions.fetchDocuments());
      this.setState({ fromNotificationsTexts: undefined });
    };

    this.props.dispatch(setRefreshFn(refreshFn));
  }

  componentDidUpdate() {
    const { from, id, texts } = this.props.location.state || {};
    const isFromNotifications = from === 'notifications' && Boolean(id);

    if (isFromNotifications) {
      this.props.dispatch(documentsActions.getDocumentByNumber(id));
      this.setState({ fromNotificationsTexts: texts });
      this.props.history.replace({ state: undefined });
    }
  }

  handleDocumentAdd = () => {
    this.props.dispatch(
      newDocumentActions.openNewDocumentModal(this.props.request)
    );
  };

  handleTest = () => {
    this.props.dispatch(newDocumentActions.openCreateDocument());
  };

  handleResetFilter = () => {
    resetDocumentDefaultFilter(this.props.chosenFilterId);
    this.props.dispatch(documentsActions.resetFilter());
  };

  handleResetFilterTest = () => {
    resetDocumentDefaultFilter(this.props.chosenFilterIdNew);
    this.props.dispatch(resetFilter());
  };

  render() {
    // const menuFilter = (
    //   <Menu onClick={this.handleResetFilter}>
    //     <Menu.Item>
    //       <Icon
    //         type="sync"
    //         style={{
    //           marginRight: 10,
    //           verticalAlign: 'middle',
    //           fontSize: '24px',
    //           color: '#999',
    //         }}
    //       />
    //       Сбросить
    //     </Menu.Item>
    //   </Menu>
    // );

    const menuFilter = (
      <Menu onClick={this.handleResetFilterTest}>
        <Menu.Item>
          <Icon
            type="sync"
            style={{
              marginRight: 10,
              verticalAlign: 'middle',
              fontSize: '24px',
              color: '#999',
            }}
          />
          Сбросить
        </Menu.Item>
      </Menu>
    );

    let newDoc;
    if (this.props.postDocumentID) {
      const docs = this.props.documents;
      newDoc = docs.find(
        (e) => String(e.id) === String(this.props.postDocumentID)
      );
    }

    return (
      <div style={{ overflowY: 'scroll' }}>
        {this.props.apiResponseError && (
          <Alert
            message={
              this.props.apiResponseText + ' : ' + this.props.apiResponseUrl
            }
            type="error"
            showIcon
          />
        )}
        {this.props.postDocumentID && newDoc && (
          <Alert
            onClose={() => {
              this.props.dispatch(newDocumentActions.resetPostedDocument());
              this.props.dispatch(documentsActions.fetchDocuments());
            }}
            message={
              <Row gutter={16}>
                <Col span={24}>Документ создан</Col>
              </Row>
            }
            description={
              <div>
                {[
                  {
                    key: 'Тип',
                    label: 'Тип',
                    value: newDoc.type.name,
                  },
                  {
                    key: 'Тема',
                    label: 'Тема',
                    value: newDoc.topic,
                  },
                  {
                    key: 'Номер',
                    label: 'Номер',
                    value: getDocTitle(newDoc),
                  },
                ].map((row) => (
                  <Row
                    key={row.key}
                    gutter={16}
                  >
                    <Col
                      style={{ textAlign: 'right' }}
                      offset={9}
                      span={3}
                    >
                      {row.label}
                    </Col>
                    <Col
                      style={{ textAlign: 'left', fontWeight: 'bold' }}
                      span={12}
                    >
                      {row.value}
                    </Col>
                  </Row>
                ))}
              </div>
            }
            type="success"
            closable
            showIcon
          />
        )}
        {Boolean(
          this.state.fromNotificationsTexts && !this.props.dataFetching
        ) && (
          <FromNotificationAlert
            {...this.state.fromNotificationsTexts}
            hasData={this.props.documents?.length > 0}
            onClose={() => {
              this.setState({ fromNotificationsTexts: undefined });
              this.getDefaultFilter();
            }}
          />
        )}
        <Affix
          className="dispex-filter-button"
          offsetTop={8}
        >
          <div style={{ paddingRight: 10 }}>
            {/* {this.props.userInfo.CanCreateRequestInWeb && (
              <Tooltip
                title="Добавить документ"
                placement="bottom"
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon="plus"
                  style={{ marginRight: '10px' }}
                  onClick={this.handleDocumentAdd}
                />
              </Tooltip>
            )} */}
            {this.props.userInfo.CanCreateRequestInWeb && (
              <Tooltip
                title="Добавить документ"
                placement="bottomLeft"
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon="plus"
                  style={{ marginRight: '10px' }}
                  onClick={this.handleTest}
                />
              </Tooltip>
            )}

            <MassDownload />
            {/* <DeleteDocuments /> */}
            <ExpiredDocsButton />
            <Search
              style={{ width: '250px', marginRight: '10px' }}
              placeholder="найти документ"
              onSearch={(value) => {
                this.props.dispatch(
                  documentsActions.searchDocuments(value, this.props)
                );
              }}
              enterButton
            />
            {this.props.userInfo.ConfigureDocs && <CompanyDocumentReminder />}
            {/* <Tooltip
              title="Фильтр"
              placement="left"
            >
              <Dropdown
                overlay={menuFilter}
                placement="bottomLeft"
              >
                <Button
                  style={{ marginRight: '10px' }}
                  icon="filter"
                  onClick={() => {
                    this.props.dispatch(documentsActions.closeFilter(true));
                  }}
                >
                  {this.props.chosenFilterName && (
                    <span style={{ marginLeft: 10 }}>
                      {shortFilterName(this.props.chosenFilterName)}
                    </span>
                  )}
                </Button>
              </Dropdown>
            </Tooltip> */}
            <Tooltip
              title="Фильтр"
              placement="left"
            >
              <Dropdown
                overlay={menuFilter}
                placement="bottomLeft"
              >
                <Button
                  style={{ marginRight: '10px' }}
                  icon="filter"
                  onClick={() => {
                    this.props.dispatch(
                      documentsActions.setFilterNewVisible(true)
                    );
                  }}
                >
                  {this.props.chosenFilterNameNew && (
                    <span style={{ marginLeft: 10 }}>
                      {shortFilterName(this.props.chosenFilterNameNew)}
                    </span>
                  )}
                </Button>
              </Dropdown>
            </Tooltip>
          </div>
        </Affix>
        <FilterDrawer />
        <FilterDrawerNew />
        <NewRequestContainer />
        <NewDocumentContainer />
        <DocForm />
        <EditDocumentContainer />
        <WarrantyContainer />
        <WarrantyInfoContainer />
        <OrgInParamsFormContainer />
        <AddOrgsContainer />
        <ExecuterContainer />
        <MasterContainer />
        <ServiceContainer />
        <RelatedDocsModal />
        <Spin
          size="large"
          spinning={this.props.dataFetching}
          tip="Загрузка..."
        >
          <DocumentsTable />
        </Spin>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { documentsStore } = state;
  const {
    listOrdType,
    listOssType,
    listContractType,
    listExecuter,
    listDocumentType,
    postDocumentID,
    listAddrStreet,
    listServiceCompanies,
  } = state.newDocumentStore;
  const { documentContractors } = state.contractorStore;
  const { userInfo } = state.authentication;
  const { newWarranty, setWarrantyRequestID } = state.warrantyStore;
  const { previewUrl, previewFileName, showPreview, previews } =
    state.requestsStore;
  const { filters, chosenFilterName, chosenFilterId } =
    state.documentFilterStore;
  const {
    chosenFilterId: chosenFilterIdNew,
    chosenFilterName: chosenFilterNameNew,
  } = state.newDocumentStore;

  return {
    ...documentsStore,
    userInfo,
    newWarranty,
    setWarrantyRequestID,
    previewUrl,
    previewFileName,
    showPreview,
    postDocumentID,
    listDocumentType,
    listOrdType,
    listOssType,
    listContractType,
    listExecuter,
    documentContractors,
    listAddrStreet,
    previews,
    filters,
    chosenFilterName,
    chosenFilterId,
    listServiceCompanies,
    chosenFilterIdNew,
    chosenFilterNameNew,
  };
}

export default connect(mapStateToProps)(withRouter(DocumentsContainer));
